import { Dispatch, FC, SetStateAction } from 'react'

import { FiltersProviderV2 } from '../../contexts/FiltersContextV2'
import {
  BlocktrainDetail,
  BlockTrainStatusEnum,
  RailcarDetail,
  SupplierPurchaseOrder,
} from '../../types'
import RailcarsTabPaneContent from '../RailcarsTabPaneContent'

interface RailcarsTabPaneProps {
  blocktrain: BlocktrainDetail
  allowedEditingStatus: BlockTrainStatusEnum[]
  setSelectedRailcar: Dispatch<SetStateAction<RailcarDetail | undefined>>
  blocktrainsIsLoading?: boolean
  setAddModalIsOpen?: Dispatch<SetStateAction<boolean>>
  purchaseOrders?: SupplierPurchaseOrder[]
  materialsOptions?: {
    label: string
    value: number
  }[]
  purchaseOrdersIsLoading?: boolean
}

const RailcarsTabPane: FC<RailcarsTabPaneProps> = ({
  blocktrain,
  blocktrainsIsLoading,
  allowedEditingStatus,
  setSelectedRailcar,
  setAddModalIsOpen,
  purchaseOrders,
  materialsOptions,
  purchaseOrdersIsLoading,
}) => {
  return (
    <FiltersProviderV2 key="filtersAdminSuppliers" customized={{ limit: 10 }}>
      <RailcarsTabPaneContent
        blocktrain={blocktrain}
        blocktrainsIsLoading={blocktrainsIsLoading}
        allowedEditingStatus={allowedEditingStatus}
        setSelectedRailcar={setSelectedRailcar}
        setAddModalIsOpen={setAddModalIsOpen}
        materialsOptions={materialsOptions}
        purchaseOrders={purchaseOrders}
        purchaseOrdersIsLoading={purchaseOrdersIsLoading}
      />
    </FiltersProviderV2>
  )
}

export default RailcarsTabPane
